(function recommendationEvents(global) {
  'use strict';

  const queryElementWithEvents = {
    onRecommendationSend: '[data-direct-lead-recommendation]',
    onRecommendationUnCheck: '[data-direct-lead-recommendation-uncheck]'
  };

  global.NewHomeSource = global.NewHomeSource || {};
  const previousRecommendationEvents = global.NewHomeSource.RecommendationEvents;

  if (previousRecommendationEvents) {
    return;
  }

  /**
   * @private
   * getAttributes: get the attributes that starts with @var{attribute}
   *
   * @param {DOMStringMap} dataset properties of the object.
   * @param {*} prefix to evaluate the properties we want to retrieve.
   * @param {*} attribute being evaluated.
   * @returns object with the property.
   */
  function getAttributes(dataset, prefix, attribute) {
    if (!attribute.startsWith(prefix)) {
      return;
    }

    const cleanProperty = attribute.replace(prefix, '');
    if (!cleanProperty) {
      return;
    }

    const name = cleanProperty.charAt(0).toLowerCase() + cleanProperty.slice(1);

    if (!name) {
      return;
    }

    this[name] = dataset[attribute];
  }

  /**
   * triggerRecommendationEvents: when user send a recommendation lead,
   * we have the possiblity to send two events certain one condition
   * If we have at least one community we use the data in the element [data-direct-lead-recommendation]
   * otherwise it means the user uncheck all the communities or use skip button, and use the data in
   * [data-direct-lead-recommendation-uncheck].
   *
   * @param {Event} event with the informationa bout how many communities the user check.
   */
  function triggerRecommendationEvents(event) {
    const selector = queryElementWithEvents[event.type];
    const detail = event.detail || {};
    if (!selector) {
      return;
    }
    const elementToSelect = detail.form || global.document;
    const element = elementToSelect.querySelector(selector);
    if (element) {
      const dataset = element.dataset;
      const params = {};
      Object.keys(dataset).forEach(getAttributes.bind(params, dataset, 'ga4'));
      if (Object.keys(params).length > 0) {
        const eventName = params.eventName;
        const eventGa4 = {
          eventName,
          params,
          eventType: 'GA4Event'
        };

        document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
          detail: { data: eventGa4 }
        }));
      }
    }
  }

  function RecommendationEvents() {
  }

  RecommendationEvents.triggerRecommendationEvents = triggerRecommendationEvents;

  global.NewHomeSource.RecommendationEvents = RecommendationEvents;

  document.body.addEventListener('onRecommendationSend', triggerRecommendationEvents);
  document.body.addEventListener('onRecommendationUnCheck', triggerRecommendationEvents);
}(window));

define("recommendationEvents", function(){});

